import {Component, HostListener, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MainComponent} from './core/main.component';
import {AppService} from './services/app.service';
import {NavigationService} from './services/navigation.service';
import {UserModelService} from './models/user-model.service';
import {IonRouterOutlet, Platform} from '@ionic/angular';
import {fromEvent, Observable} from 'rxjs';
import {AngularFireMessaging} from '@angular/fire/compat/messaging';
import {HelperService} from './services/helper.service';
import {environment} from '../environments/environment';
import {Router} from '@angular/router';

// import {getMessaging, onMessage} from 'firebase/messaging';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent extends MainComponent implements OnInit, OnDestroy {

  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  loadStepCount = 1;

  platform: Platform;

  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;

  menuRoutes: any[] = [];

  router = inject(Router);
  afMessaging: AngularFireMessaging;

  constructor(
    appService: AppService,
    navigationService: NavigationService,
    platform: Platform,
    userModelService: UserModelService,
    afMessaging: AngularFireMessaging
  ) {
    super(appService, navigationService, userModelService);

    this.platform = platform;
    this.afMessaging = afMessaging;

    this.initializeApp();
  }

  async initializeApp() {

    this.appService.setTitle(environment.title);

    this.processPushFromLink();
    this.handleAppConnectivityChanges();

    this.onResize();

    this.platform.ready().then(() => {

      this.requestPushNotificationsPermission();

      this.navigationService.routerOutlet = this.routerOutlet;

      this.navigationService.entryUrl = window.location.pathname;
      this.userModelService.setToken(this.appService.getLocalStorage('token'));

      this.userModelService.makeLogin(() => {

        if (this.userModelService.isLogin()) {
          this.navigationService.getMenuRoutes();
        }

        this.afMessaging.requestToken // getting tokens
          .subscribe(
            (token) => { // USER-REQUESTED-TOKEN
              const deviceToken = this.appService.getLocalStorage('deviceToken');
              console.log('Permission granted! Save to the server!', token);

              this.appService.setLocalStorage('deviceToken', token);
            },
            (error) => {
              console.error(error);
            }
          );

        this.checkLoading();
      });

      this.platform.backButton.subscribeWithPriority(1, () => {
        // navigator['app'].exitApp();
        this.navigationService.back();
      });
    });

    // await this.appService.showLoading();
  }

  processPushFromLink() {
    const pushData = HelperService.parseUrlForPushData();
    if (pushData) {
      const page = window.location.href.replace(window.location.search, '');
      window.history.replaceState({path: page}, '', page);

      pushData.page = page.replace('/', '');
      this.appService.pushData = pushData;
    }
  }

  requestPushNotificationsPermission() {

    navigator.serviceWorker?.addEventListener('message', (event) => {
      if (typeof event?.data?.messageType != 'undefined') {

        console.log('Push', event);

        if (event?.data?.messageType === 'notification-clicked') {
          this.processPushData(event?.data.data, event?.data.notification);
        } else {
          this.appService.showToast(event?.data.notification.body, 'primary', 'Открыть', () => {
            this.processPushData(event?.data.data, event?.data.notification);
          }, 20000);
        }

      }
    });

    // const broadcast = new BroadcastChannel('push-channel');
    // broadcast.onmessage = (event) => {
    //   // alert(event.data.notification.title);
    // };
  }

  processPushData(data, notification) {
    const url = new URL(notification.click_action);
    this.navigationService.processActionData(data, url.pathname.replace('/', ''));
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.appService.back();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  async onAppLoaded() {
    this.appService.appReady = true;

    setTimeout(async () => {
      if (this.appService.loading) {
        await this.appService.hideLoading();
      }
    }, 1000);


    // this.navigationService.goAfterLogin(this.userModelService.isLogin());
  }

  ngOnInit() {

    // const myObject = {1: 'Test 1', 435: 'Blabal', 20: 'Yolo'};
    // const res = Object.entries(myObject).map((item) => {
    //   return {id: item[0], title: item[1]};
    // });
    //
  }

  ngOnDestroy() {
  }

  checkLoading() {
    this.loadStepCount--;

    if (this.loadStepCount <= 0) {
      this.onAppLoaded();
    }
  }

  private handleAppConnectivityChanges(): void {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      // // handle online mode
      // console.log('Online...');
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.appService.setOffline();
    }));
  }

}
